<template>
    <div>
        <strong>Description:</strong>
        <p>
            Gets all fitterHours with cost 0, and checks if the <sui-label>Category</sui-label> cost is also 0
        </p>
        <!-- <p v-if="hasTechDataCount || noTechDataCount">
            Found <strong>{{ hasTechDataCount }}</strong> tasks with technical data,<strong>{{ partialTechDataCount }}</strong> tasks with partial technical data, <strong>{{ noTechDataCount }}</strong> tasks without technical data.
        </p> -->
        <hr />

        <sui-button primary size="tiny" :loading="isRunning" :disabled="isRunning" @click="triggerDry">Run Dry</sui-button>
        <!-- <sui-button negative size="tiny" :loading="isRunning" :disabled="isRunning" @click="triggerNormal">Run</sui-button> --> <!--NEVER RUN MORE THAN ONCE ON THE SAME DATE RANGE, AS IT WILL DUPLICATE ALL HOURS WITH ERROR-->
        <sui-button negative size="tiny" :disabled="!isRunning" @click="stop">STOP</sui-button>
    </div>
</template>
<script>
import EKomplet from '@/lib/DataProviders/EKomplet.js' 
const EkompletInstance = new EKomplet();

export default {
    name: 'RevertZeroCostHours',

    data() {
        return {
            isRunning: false,
            dryRun: true,
            shouldStop: false,
        }
    },

    methods: {
        log(message) {
            this.$emit('log', message);
        },

        async triggerDry() {
            this.dryRun = true;
            await this.trigger();
        },

        async triggerNormal() {
            this.dryRun = false;
            await this.trigger();
        },

        stop() {
            this.shouldStop = true;
        },

        async trigger() {
            this.isRunning = true;
            this.log(`----------------`);
            this.log(`Starting process`);

            if (this.dryRun) {
                this.log(`Dry mode - No updates will actually occur.`);
            }
            this.log('----------------');

            this.log('Fetching fitter categories...')
            let categories;
            try {      
                categories = await EkompletInstance.getFitterCategories();
            } catch (error) {
                this.log(`Error fetching categories: ${error.message}`);
                this.isRunning = false;
                return;
            }
            this.log(`Fetched ${categories.length} categories.`);

            this.log('Fetching fitter hours with cost 0...')
            let hours;
            try {
                hours = await EkompletInstance.getFitterHours(new Date('2025-08-01'), new Date(), 'HourRate', '0');
            } catch (error) {
                this.log(`Error fetching hours: ${error.message}`);
                this.isRunning = false;
                return;
            }
            this.log(`Fetched ${hours.length} hours with cost 0.`);

            const negatedHours = [];
            const updatedHours = [];
            const affectedSalaryIds = new Set();
            let earliestDate = null;
            let latestDate = null;

            for (const hour of hours) {
                if (this.shouldStop) {
                    this.log('Process stopped by user.');
                    this.isRunning = false;
                    return;
                }

                const category = categories.find(cat => cat.ID === hour.FitterCategoryID);
                if (category && category.HourRate > 0) {
                    if (hour.HourRate != 0) {
                        this.log(`!!!!Warning: Hour ID ${hour.ID} has cost ${hour.HourRate} but was fetched in 0-cost query. Skipping.`);
                        continue;
                    }
                    this.log(`Hour ID ${hour.ID} on ${hour.Date} for Fitter ${hour.FitterSalaryID} and Project '${hour.ProjectName}' has ${hour.HourRate} cost but category ${category.Description} has cost ${category.HourRate}. Preparing to update.`);
                    affectedSalaryIds.add(hour.FitterSalaryID);
                    if (!earliestDate || hour.Date < earliestDate) {
                        earliestDate = hour.Date;
                    }
                    if (!latestDate || hour.Date > latestDate) {
                        latestDate = hour.Date;
                    }
                    negatedHours.push({
                        date: hour.Date,
                        fitterID: hour.FitterID,
                        projectID: hour.ProjectID,
                        fitterCategoryId: hour.FitterCategoryID,
                        count: -hour.Hours,
                        hourRate: 0,
                        note: `Automatisk korrektion af time med 0kr kostpris. Oprindelig note: ${hour.Note}`,
                    });
                    updatedHours.push({
                        date: hour.Date,
                        fitterID: hour.FitterID,
                        projectID: hour.ProjectID,
                        fitterCategoryId: hour.FitterCategoryID,
                        count: hour.Hours,
                        hourRate: category.HourRate,
                        note: `${hour.Note} (Opdateret automatisk fra 0kr til ${category.HourRate}kr kostpris)`,
                    });
                }
            }

            this.log('----------------');
            this.log(`Prepared ${negatedHours.length} negated hours and ${updatedHours.length} updated hours.`);
            this.log(`A total of ${affectedSalaryIds.size} salary IDs are affected: ${[...affectedSalaryIds].join(', ')}`);
            this.log(`Date range affected: ${earliestDate ? earliestDate.split('T')[0] : 'N/A'} to ${latestDate ? latestDate.split('T')[0] : 'N/A'}`);
            this.log('----------------');

            if (negatedHours.length !== updatedHours.length) {
                this.log('Mismatch in negated and updated hours count! Aborting.');
                this.isRunning = false;
                return;
            }

            if (this.dryRun) {
                this.log('Dry run - no changes will be made.')
                this.log('----------------');
                this.log(`Would create the following negated hours:`);
                negatedHours.forEach(hour => {
                    if (this.shouldStop) {
                        this.isRunning = false;
                        return;
                    }
                    this.log(JSON.stringify(hour));
                });
                this.log(`Would create the following updated hours:`);
                this.log('----------------');
                updatedHours.forEach(hour => {
                    if (this.shouldStop) {
                        this.isRunning = false;
                        return;
                    }
                    this.log(JSON.stringify(hour));
                });
            } else {
                this.log(`Creating negated hours...`)
                this.log('----------------');
                try {
                    await EkompletInstance.postFitterHours(negatedHours);
                    this.log(`Successfully created negated hours.`);
                } catch (error) {
                    this.log(`Error creating negated hours: ${error.message}`);
                    this.isRunning = false;
                    return;
                }
                this.log(`Creating updated hours...`)
                this.log('----------------');
                try {
                    await EkompletInstance.postFitterHours(updatedHours);
                    this.log(`Successfully created updated hours.`);
                } catch (error) {
                    this.log(`Error creating updated hours: ${error.message}`);
                    this.isRunning = false;
                    return;
                }
            }
            

            this.log(`----------------`);
            this.log(`Finished process`);

            this.isRunning = false
        }
    }
}
</script>
<style scoped>
.float.right {
    float: right;
}
</style>